import { Flex, Spacing, Text } from '@billy/design-system'

import * as Styled from './styles'

interface ReceiptInfoFieldProps {
  label: string
  value: string | null | undefined
}

export const ReceiptInfoField = ({ label, value }: ReceiptInfoFieldProps) => {
  if (!value) {
    return null
  }

  return (
    <Flex flexDirection="column" gap={Spacing.S8}>
      <Text variant="bodySM" colorVariant="secondary">
        {label}
      </Text>
      <Styled.ValueWrapper>
        <Text>{value}</Text>
      </Styled.ValueWrapper>
    </Flex>
  )
}
